module.exports = __webpack_public_path__ + "static/media/leftside.c4b3922d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/atlas/dinerGame/leftside.png
// module id = 2324
// module chunks = 0